module.exports = __webpack_public_path__ + "static/media/more-light.118d6bc1.svg";